/* Mass'Focus — barre livraison offerte, badges de confiance, pop-up bienvenue */
(function () {
  var CFG = window.MF_CFG || {};
  var FREE = CFG.freeShipping || 5500; // en centimes
  function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* ---------- Barre « livraison offerte » dans le panier ---------- */
  function barHtml(total) {
    if (total >= FREE) {
      return '<div class="mf-ship-bar mf-ship-bar--ok" data-mf-ship><strong>Livraison offerte</strong> sur votre commande.</div>';
    }
    var left = FREE - total, pct = Math.max(4, Math.min(100, Math.round(total / FREE * 100)));
    return '<div class="mf-ship-bar" data-mf-ship>Plus que <strong>' + euros(left) + '</strong> pour la livraison offerte (dès 2 sachets).' +
      '<div class="mf-ship-bar__track"><div class="mf-ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  }
  var pending = false;
  function refreshBars() {
    if (pending) return; pending = true;
    setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        pending = false;
        var anchors = document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href^="/checkout"]');
        anchors.forEach(function (btn) {
          var host = btn.parentElement; if (!host) return;
          var old = host.querySelector(':scope > [data-mf-ship]');
          if (!cart.item_count) { if (old) old.remove(); return; }
          var html = barHtml(cart.total_price);
          if (old) { if (old.outerHTML !== html) old.outerHTML = html; }
          else btn.insertAdjacentHTML('beforebegin', html);
        });
      }).catch(function () { pending = false; });
    }, 250);
  }
  document.addEventListener('cart:update', refreshBars);
  document.addEventListener('DOMContentLoaded', refreshBars);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].addedNodes;
      for (var j = 0; j < n.length; j++) {
        if (n[j].nodeType === 1 && (n[j].matches && (n[j].matches('[name="checkout"]') || n[j].querySelector && n[j].querySelector('[name="checkout"]')))) { refreshBars(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Badges de confiance sous « Ajouter au panier » ---------- */
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  var BADGES = ['Marque française', 'Usine certifiée FSSC 22000', 'Livraison offerte dès 2 sachets', 'Paiement sécurisé'];
  function addTrust() {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main || main.querySelector('.mf-trust')) return;
    var atc = main.querySelector('add-to-cart-component');
    if (!atc) return;
    var form = atc.closest('form') || atc.parentElement;
    var ul = document.createElement('ul');
    ul.className = 'mf-trust';
    ul.innerHTML = BADGES.map(function (b) { return '<li>' + ICON + '<span>' + b + '</span></li>'; }).join('');
    form.insertAdjacentElement('afterend', ul);
  }
  document.addEventListener('DOMContentLoaded', addTrust);

  /* ---------- Pop-up de bienvenue ---------- */
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function initPopup() {
    var pop = document.getElementById('mf-nl'); if (!pop) return;
    var close = function () { pop.hidden = true; store('mf_nl_seen', String(Date.now())); };
    pop.querySelector('.mf-nl__close').addEventListener('click', close);
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    var justPosted = /customer_posted=true/.test(location.search) || pop.querySelector('.mf-nl__ok, .mf-nl__err');
    if (justPosted) { pop.hidden = false; if (pop.querySelector('.mf-nl__ok')) store('mf_nl_done', '1'); return; }
    if (store('mf_nl_done')) return;
    var seen = +store('mf_nl_seen') || 0;
    if (Date.now() - seen < 14 * 24 * 3600 * 1000) return;
    if (/^\/(cart|checkout|account|pages\/(cgv|mentions-legales|retours|livraison))/.test(location.pathname)) return;
    var shown = false;
    var show = function () { if (shown) return; shown = true; pop.hidden = false; var i = pop.querySelector('input[type=email]'); if (i) i.focus(); };
    setTimeout(show, 15000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) show(); });
  }
  document.addEventListener('DOMContentLoaded', initPopup);
})();
